import React, { ReactNode } from "react";
import * as Styled from "./ReportContainer.styles";

interface ReportContainerProps {
    variant: "document" | "html";
    children?: ReactNode;
}

export const ReportContainer = ({ variant, children }: ReportContainerProps) => {
    return (
        <Styled.Container variant={variant}>{children}</Styled.Container>
    );
};
